import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=5c1f416c&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c1f416c')) {
      api.createRecord('5c1f416c', component.options)
    } else {
      api.reload('5c1f416c', component.options)
    }
    module.hot.accept("./Document.vue?vue&type=template&id=5c1f416c&", function () {
      api.rerender('5c1f416c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/library/Document.vue"
export default component.exports